/*
 * SWITCH VARIANT - a list card offers the other values of the main
 * (variant-forming) characteristic of its product; a click shows that variant on
 * the card (price, images) without leaving the list. Which characteristic is the
 * main one is the tenant's setting (main_characteristics) - nothing here names it.
 *
 * Markup: <button class="switch-variant" data-id="{product id}" data-value="{value id}">
 * inside the card; the card is the button's parent's parent, with a .price element and
 * .l-images .pure-img images. Endpoint: GET /api/product/variant/{product}/{value}.
 */
const switchVariant = {
    load() {
        const btns = document.getElementsByClassName('switch-variant');
        for (const btn of btns) {
            if (btn.dataset.bound) continue;
            btn.dataset.bound = '1';
            btn.addEventListener('click', (e) => {
                const card = e.currentTarget.parentNode.parentNode;

                fetch("/api/product/variant/" + e.currentTarget.dataset.id + "/" + e.currentTarget.dataset.value, {
                    headers: http.headers(),
                }).then((response) => response.json()).then((data) => {
                    if (!data.product) return; // "no result" / not found: the card stays

                    const price = card.getElementsByClassName("price")[0];
                    if (price) {
                        price.innerHTML = data.product.discount !== undefined
                            ? "<div class=\"price-original\">" + data.product.price + "</div> " + data.product.discount
                            : data.product.price;
                    }

                    const images = card.querySelectorAll(".l-images .pure-img");
                    let i = 0;
                    for (const image of images) {
                        if (data.product.productImages.length > i) {
                            image.srcset = data.product.productImages[i].srcset;
                            image.src = data.product.productImages[i].src;
                        } else {
                            image.remove();
                        }
                        i++;
                    }
                });
            });
        }
    },
};

window.addEventListener('DOMContentLoaded', () => {
    switchVariant.load();
});
if (document.readyState !== 'loading') {
    switchVariant.load();
}
window.switchVariant = switchVariant;
